"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomMarkerClass = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("../../../../../store/index"));
const popoverSlice_1 = require("../../../../../store/popoverSlice");
const NotesPopover_1 = require("../NotesPopover/NotesPopover");
function createCustomMarkerClass() {
    return class CustomMarker extends google.maps.OverlayView {
        constructor(position, color, title, size = 12, clickableAreaSize = 20, paneName = "overlayMouseTarget", notes = [], content, onClick, invisible = false, initialSlide = 0) {
            super();
            this.div = null;
            this.pulsating = false;
            this.zIndex = 0;
            this.noteContainers = new Map();
            this.notesPopover = null;
            this.invisible = false;
            this.initialSlide = 0;
            this.clickHandler = null;
            this.position = new google.maps.LatLng(position);
            this.color = color;
            this.title = title;
            this.size = size;
            this.content = content;
            this.onClick = onClick;
            this.clickableAreaSize = clickableAreaSize;
            this.paneName = paneName;
            this.notes = notes;
            this.invisible = invisible;
            this.initialSlide = initialSlide;
        }
        onAdd() {
            this.div = document.createElement("div");
            this.div.style.position = "absolute";
            this.div.style.cursor = "pointer";
            this.div.title = this.title;
            this.div.style.width = `${this.clickableAreaSize}px`;
            this.div.style.height = `${this.clickableAreaSize}px`;
            if (!this.invisible) {
                const innerDiv = document.createElement("div");
                innerDiv.style.width = `${this.size}px`;
                innerDiv.style.height = `${this.size}px`;
                innerDiv.style.borderRadius = "50%";
                innerDiv.style.backgroundColor = this.color;
                innerDiv.style.position = "absolute";
                innerDiv.style.top = "50%";
                innerDiv.style.left = "50%";
                innerDiv.style.transform = "translate(-50%, -50%)";
                this.div.appendChild(innerDiv);
            }
            if (this.content) {
                this.root = (0, client_1.createRoot)(this.div);
                this.root.render(react_1.default.createElement(react_redux_1.Provider, { store: index_1.default }, this.content));
            }
            if (this.onClick) {
                this.div.addEventListener("click", this.onClick);
            }
            // Store click handler for cleanup
            this.clickHandler = () => {
                const map = this.getMap && this.getMap();
                if (map && map instanceof window.google.maps.Map) {
                    CustomMarker.closeAllPopovers(map);
                }
            };
            if (this.div) {
                this.div.addEventListener("click", this.clickHandler);
            }
            if (this.pulsating && !this.invisible) {
                this.div.classList.add("pulsating-marker");
            }
            const markerKey = `${this.position.lat()},${this.position.lng()}`;
            const state = index_1.default.getState();
            const openMarkerKey = state.popover.openMarkerKey;
            const initialSlide = state.popover.initialSlide;
            if (this.notes && this.notes.length > 0) {
                this.createNoteContainer(markerKey, openMarkerKey || "", initialSlide);
            }
            const panes = this.getPanes();
            const pane = panes ? panes[this.paneName] : null;
            pane && pane.appendChild(this.div);
        }
        createNoteContainer(markerKey, openMarkerKey, initialSlide) {
            if (!this.div)
                return;
            const noteContainer = document.createElement("div");
            noteContainer.setAttribute("data-note-container", "marker");
            noteContainer.style.position = "absolute";
            noteContainer.style.top = "-35px";
            noteContainer.style.left = "0px";
            noteContainer.style.zIndex = "1000";
            const root = (0, client_1.createRoot)(noteContainer);
            root.render(react_1.default.createElement(react_redux_1.Provider, { store: index_1.default },
                react_1.default.createElement(NotesPopover_1.NotesPopover, { notes: this.notes, initialSlide: markerKey === openMarkerKey ? initialSlide : 0, open: markerKey === openMarkerKey, onOpen: () => {
                        const markerLat = this.position.lat();
                        const markerLng = this.position.lng();
                        const noteIndex = this.notes.findIndex((note) => note.latitude === markerLat && note.longitude === markerLng);
                        index_1.default.dispatch((0, popoverSlice_1.openPopover)({
                            markerKey,
                            initialSlide: noteIndex >= 0 ? noteIndex : 0,
                        }));
                    }, onClose: () => index_1.default.dispatch((0, popoverSlice_1.closePopover)()), onSlideChange: (note, index) => {
                        const newKey = `${note.latitude},${note.longitude}`;
                        if (newKey !== markerKey) {
                            index_1.default.dispatch((0, popoverSlice_1.openPopover)({ markerKey: newKey, initialSlide: index }));
                        }
                    } })));
            this.div.appendChild(noteContainer);
            this.noteContainers.set("marker", root);
            // Register this marker for global lookup
            const map = this.getMap();
            if (map) {
                if (!map.__customMarkers) {
                    map.__customMarkers = new Set();
                }
                map.__customMarkers.add(this);
            }
        }
        draw() {
            if (!this.div)
                return;
            const overlayProjection = this.getProjection();
            const position = overlayProjection.fromLatLngToDivPixel(this.position);
            if (position) {
                const offsetX = this.clickableAreaSize / 2;
                const offsetY = this.clickableAreaSize / 2;
                this.div.style.left = `${position.x - offsetX}px`;
                this.div.style.top = `${position.y - offsetY}px`;
                // Update note container position if it exists
                const noteContainer = this.div.querySelector('[data-note-container="marker"]');
                if (noteContainer) {
                    noteContainer.style.position = "absolute";
                    noteContainer.style.top = "-35px";
                    noteContainer.style.left = "0px";
                    noteContainer.style.zIndex = "1000";
                }
            }
        }
        onRemove() {
            var _a;
            // Deregister from global lookup
            const map = this.getMap();
            if (map && map.__customMarkers) {
                map.__customMarkers.delete(this);
            }
            if (this.div) {
                if (this.onClick) {
                    this.div.removeEventListener("click", this.onClick);
                }
                if (this.clickHandler) {
                    this.div.removeEventListener("click", this.clickHandler);
                }
                (_a = this.div.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.div);
                this.div = null;
            }
            // Clean up React roots
            if (this.root) {
                this.root.unmount();
                this.root = undefined;
            }
            // Clean up note containers
            this.noteContainers.forEach((root) => {
                try {
                    root.unmount();
                }
                catch (e) {
                    console.warn("Error unmounting note container:", e);
                }
            });
            this.noteContainers.clear();
            if (this.notesPopover) {
                this.notesPopover.remove();
                this.notesPopover = null;
            }
        }
        setPosition(position) {
            this.position =
                position instanceof google.maps.LatLng
                    ? position
                    : new google.maps.LatLng(position.lat, position.lng);
            this.draw();
        }
        setColor(color) {
            this.color = color;
            if (this.div) {
                const innerDiv = this.div.firstChild;
                if (innerDiv) {
                    innerDiv.style.backgroundColor = color;
                }
            }
        }
        setTitle(title) {
            this.title = title;
            if (this.div) {
                this.div.title = title;
            }
        }
        setSize(size) {
            this.size = size;
            if (this.div) {
                const innerDiv = this.div.firstChild;
                if (innerDiv) {
                    innerDiv.style.width = `${size}px`;
                    innerDiv.style.height = `${size}px`;
                }
            }
        }
        setClickableAreaSize(size) {
            this.clickableAreaSize = size;
            if (this.div) {
                this.div.style.width = `${size}px`;
                this.div.style.height = `${size}px`;
                this.draw();
            }
        }
        getPosition() {
            return this.position;
        }
        getContent() {
            return this.content;
        }
        setContent(content) {
            this.content = content;
            if (this.div) {
                if (!this.root) {
                    this.root = (0, client_1.createRoot)(this.div);
                }
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    this.root.render(react_1.default.createElement(react_redux_1.Provider, { store: index_1.default }, this.content));
                });
            }
        }
        setZIndex(zIndex) {
            this.zIndex = zIndex;
            if (this.div) {
                this.div.style.zIndex = zIndex.toString();
            }
        }
        setPulsating(pulsating) {
            this.pulsating = pulsating;
            if (this.div) {
                if (this.pulsating) {
                    this.div.classList.add("pulsating-marker");
                }
                else {
                    this.div.classList.remove("pulsating-marker");
                }
            }
        }
        isPulsating() {
            return this.pulsating;
        }
        setNotes(notes, initialSlide = 0) {
            this.notes = notes;
            this.initialSlide = initialSlide;
            // Clean up existing note containers immediately
            this.noteContainers.forEach((root) => {
                try {
                    root.unmount();
                }
                catch (e) {
                    console.warn("Error unmounting note container:", e);
                }
            });
            this.noteContainers.clear();
            // Remove existing note elements
            if (this.div) {
                const noteElements = this.div.querySelectorAll("[data-note-container]");
                noteElements.forEach((el) => el.remove());
            }
            // Only add new note container if there are notes at this marker's position
            if (this.notes && this.notes.length > 0 && this.div) {
                const markerKey = `${this.position.lat()},${this.position.lng()}`;
                const state = index_1.default.getState();
                const openMarkerKey = state.popover.openMarkerKey;
                const reduxInitialSlide = state.popover.initialSlide;
                this.createNoteContainer(markerKey, openMarkerKey || "", reduxInitialSlide);
            }
            this.draw();
        }
        clearNotes() {
            // Clear all note containers in one batch
            this.noteContainers.forEach((root) => {
                Promise.resolve().then(() => root.unmount());
            });
            this.noteContainers.clear();
            // Remove note elements
            if (this.div) {
                const noteElements = this.div.querySelectorAll("[data-note-container]");
                noteElements.forEach((el) => el.remove());
            }
            if (this.notesPopover) {
                this.notesPopover.remove();
                this.notesPopover = null;
            }
        }
        cleanup() {
            this.setMap(null);
            this.onRemove();
        }
        static closeAllPopovers(map) {
            if (map && map.__customMarkers) {
                map.__customMarkers.forEach((marker) => { });
            }
        }
        getNotes() {
            return this.notes;
        }
    };
}
let _CustomMarkerClass = null;
function getCustomMarkerClass() {
    if (!_CustomMarkerClass) {
        _CustomMarkerClass = createCustomMarkerClass();
    }
    return _CustomMarkerClass;
}
exports.getCustomMarkerClass = getCustomMarkerClass;
